import { z } from 'zod/v4'

const BaseWorkflowRunDependencyEventSchema = z.object({
  /** the label to show the user
   *
   * eg: "Running Cadence" */
  label: z.string(),

  /** the action to perform */
  action: z.enum(['cancel', 'pause']),

  /** the event to listen for */
  listen: z.object({
    event: z.string(),
    ids: z.array(z.string()).or(z.string()),
    source: z.array(z.enum(['contact', 'member', 'agent', 'workflow-run'])),
  }),
})
const MessageCreatedWorkflowRunDependencyEventSchema =
  BaseWorkflowRunDependencyEventSchema.extend({
    event: z.literal('message.created'),
  })

const MessageSentWorkflowRunDependencyEventSchema =
  BaseWorkflowRunDependencyEventSchema.extend({
    event: z.literal('message.sent'),
  })

const MessageRejectedWorkflowRunDependencyEventSchema =
  BaseWorkflowRunDependencyEventSchema.extend({
    event: z.literal('message.rejected'),
  })

const MessageInFlightWorkflowRunDependencyEventSchema =
  BaseWorkflowRunDependencyEventSchema.extend({
    event: z.literal('message.in_flight'),
  })

const MessageDeliveredWorkflowRunDependencyEventSchema =
  BaseWorkflowRunDependencyEventSchema.extend({
    event: z.literal('message.delivered'),
  })

const ResourceUpdatedWorkflowRunDependencyEventSchema =
  BaseWorkflowRunDependencyEventSchema.extend({
    event: z.literal('resource.updated'),
  })

// add more here for orders etc...

export const WorkflowRunDependencyEventSchema = z.union([
  MessageCreatedWorkflowRunDependencyEventSchema,
  ResourceUpdatedWorkflowRunDependencyEventSchema,
  MessageSentWorkflowRunDependencyEventSchema,
  MessageRejectedWorkflowRunDependencyEventSchema,
  MessageInFlightWorkflowRunDependencyEventSchema,
  MessageDeliveredWorkflowRunDependencyEventSchema,
])
